var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffcdff;stroke-miterlimit:10;stroke-width:4.63px;}.cls-1,.cls-2{stroke:#47006f;}.cls-3{stroke:#ffcdff;}.cls-3,.cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:14.4px;}.cls-4{fill:#890031;}.cls-4,.cls-5,.cls-6{stroke-width:0px;}.cls-5{fill:#231f20;}.cls-6{fill:#ff0051;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g271"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path287",
    className: "cls-1",
    d: "m102.55,395.51V104.49c0-34.29,27.8-62.08,62.08-62.08h170.73c34.29,0,62.08,27.8,62.08,62.08v291.02c0,34.29-27.8,62.08-62.08,62.08h-170.73c-34.29,0-62.08-27.8-62.08-62.08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path291",
    className: "cls-4",
    d: "m133.59,395.51v-38.8h232.81v38.8c0,17.14-13.9,31.04-31.04,31.04h-170.73c-17.14,0-31.04-13.9-31.04-31.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g293"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path295",
    className: "cls-6",
    d: "m133.59,356.71V104.49c0-17.14,13.9-31.04,31.04-31.04h170.73c17.14,0,31.04,13.9,31.04,31.04v252.21c0,17.14-13.9,31.04-31.04,31.04h-170.73c-17.14,0-31.04-13.9-31.04-31.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g305"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path307",
    className: "cls-2",
    d: "m366.41,356.71v38.8c0,17.14-13.9,31.04-31.04,31.04h-170.73c-17.14,0-31.04-13.9-31.04-31.04v-38.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g309"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path311",
    className: "cls-3",
    d: "m275.09,183.07v-61.97l41.9,60.67c.78,1.12,1.61.57,1.61-.79l-.58-59.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path315",
    className: "cls-3",
    d: "m243.49,152.02c0,17.14-13.9,31.04-31.04,31.04s-31.04-13.9-31.04-31.04,13.9-31.04,31.04-31.04,31.04,13.9,31.04,31.04Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g317"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path319",
    className: "cls-3",
    d: "m225.53,309.17c0,15.49-15.56,31.04-31.04,31.04-17.14,0-31.04-13.9-31.04-31.04s13.9-31.04,31.04-31.04,31.04,13.9,31.04,31.04Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g321"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path323",
    className: "cls-3",
    d: "m282.29,278.13l-25.78-.62v62.08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g325"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path327",
    className: "cls-3",
    d: "m257.13,308.59h23.16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path331",
    className: "cls-3",
    d: "m336.55,278.13h-25.16v62.08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g333"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path335",
    className: "cls-3",
    d: "m311.39,308.59h23.16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g337"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path339",
    className: "cls-2",
    d: "m133.59,230.6h232.81"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g341"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path343",
    className: "cls-2",
    d: "m366.41,286.22v70.48c0,17.14-13.9,31.04-31.05,31.04h-170.72c-17.15,0-31.05-13.9-31.05-31.04V104.5c0-17.15,13.9-31.05,31.05-31.05h170.72c17.15,0,31.05,13.9,31.05,31.05v181.4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.fa3dabfca0c136ed3c216f05732e9e1f.svg";
export { ForwardRef as ReactComponent };